import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Snackbar,
  Alert,
  Button,
  Stack,
} from "@mui/material";
import { ChangeLogContext } from "../../common/context/ChangeLogContext";
import { Trans, useTranslation } from "react-i18next";
import Translator from "../I18n/Translator";

export default function ChangeLogNotification() {

  const { t } = useTranslation();

  const navigate = useNavigate();

  const {
    hasNewChangeLog,
    latestChangeLog,
    markAsSeen,
  } = useContext(ChangeLogContext);

  const handleGoToChangeLog = () => {
    markAsSeen();
    navigate("/changelog");
  };

  return (
    <Snackbar
      open={hasNewChangeLog}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{ width: "100%" }}
        action={
          <Stack direction="row" spacing={1}>
            <Button
              color="inherit"
              size="small"
              onClick={handleGoToChangeLog}
            >
              <Translator path="dashboard.ver_mudancas" />
            </Button>
            <Button
              color="inherit"
              size="small"
              onClick={markAsSeen}
            >
              <Translator path="dashboard.ignorar" />
            </Button>
          </Stack>
        }
      >
        <Translator path="dashboard.novo_log_disponivel" />
        {latestChangeLog?.versao &&
          ` (v${latestChangeLog.versao})`}
      </Alert>
    </Snackbar>
  );
}
